export const T = {
  en_GB: {
    // Header
    addView: "Add View",
    clientViewsDescription:
      "Create filtered views of the client list to group clients by specific criteria.",
    noViewsYet: "No views configured yet.",
    createViewHint: "Create a view to filter clients by specific criteria.",
    // Table
    name: "Name",
    filters: "Filters",
    default: "Default",
    actions: "Actions",
    edit: "Edit",
    standard: "(Standard)",
    cannotEdit: "Cannot edit",
    noFilters: "No filters",
    unavailableFilter: "Unavailable filter",
    // Filter display
    ownerMe: "Me",
    ownerMePlus: (count: string) => `Me + ${count}`,
    ownerUsers: (count: string) => `${count} users`,
    typePerson: "Person",
    typeCompany: "Company",
    typeGroup: "Group",
    selected: (count: string) => `${count} selected`,
    inLast: "in last",
    notInLast: "not in last",
    monthSingular: "1 month",
    monthsPlural: (count: string) => `${count} months`,
    isEmpty: "empty",
    isNotEmpty: "not empty",
    yes: "yes",
    no: "no",
    today: "today",
    thisWeek: "this week",
    thisMonth: "this month",
    thisQuarter: "this quarter",
    thisYear: "this year",
    olderThanMonth: "more than a month ago",
    olderThanQuarter: "more than a quarter ago",
    olderThanHalfYear: "more than 6 months ago",
    olderThanYear: "more than a year ago",
    // Delete confirmation
    deleteView: "Delete View",
    deleteViewConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    // Errors
    error: "Error",
    ok: "OK",
    failedToDeleteView: "Failed to delete view",
  },
  nb_NO: {
    // Header
    addView: "Legg til visning",
    clientViewsDescription:
      "Opprett filtrerte visninger av kundelisten for å gruppere kunder etter bestemte kriterier.",
    noViewsYet: "Ingen visninger konfigurert ennå.",
    createViewHint: "Opprett en visning for å filtrere kunder etter bestemte kriterier.",
    // Table
    name: "Navn",
    filters: "Filtre",
    default: "Standard",
    actions: "Handlinger",
    edit: "Rediger",
    standard: "(Standard)",
    cannotEdit: "Kan ikke redigere",
    noFilters: "Ingen filtre",
    unavailableFilter: "Utilgjengelig filter",
    // Filter display
    ownerMe: "Meg",
    ownerMePlus: (count: string) => `Meg + ${count}`,
    ownerUsers: (count: string) => `${count} brukere`,
    typePerson: "Person",
    typeCompany: "Selskap",
    typeGroup: "Gruppe",
    selected: (count: string) => `${count} valgt`,
    inLast: "i løpet av siste",
    notInLast: "ikke i løpet av siste",
    monthSingular: "1 måned",
    monthsPlural: (count: string) => `${count} måneder`,
    isEmpty: "tom",
    isNotEmpty: "ikke tom",
    yes: "ja",
    no: "nei",
    today: "i dag",
    thisWeek: "denne uken",
    thisMonth: "denne måneden",
    thisQuarter: "dette kvartalet",
    thisYear: "dette året",
    olderThanMonth: "mer enn en måned siden",
    olderThanQuarter: "mer enn et kvartal siden",
    olderThanHalfYear: "mer enn 6 måneder siden",
    olderThanYear: "mer enn et år siden",
    // Delete confirmation
    deleteView: "Slett visning",
    deleteViewConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    // Errors
    error: "Feil",
    ok: "OK",
    failedToDeleteView: "Kunne ikke slette visning",
  },
} as const;

export const ACTIVITY_DATE_LABELS = {
  en_GB: {
    lastLogin: "Last Login",
    lastInfoUpdated: "Last Updated",
    lastFlowActivity: "Last Flow Activity",
    lastFlowCompleted: "Last Flow Completed",
    lastAccountSynced: "Last Account Synced",
    lastSignedDocument: "Last Signed Document",
    createdAt: "Created",
  },
  nb_NO: {
    lastLogin: "Siste innlogging",
    lastInfoUpdated: "Sist oppdatert",
    lastFlowActivity: "Siste flytaktivitet",
    lastFlowCompleted: "Siste fullførte flyt",
    lastAccountSynced: "Siste kontosynkronisering",
    lastSignedDocument: "Siste signerte dokument",
    createdAt: "Opprettet",
  },
} as const;
